import { ClickAwayListener } from "@nova/component-click-away-listener"
import { useEffect, useState } from "react"
import { IconSizeClasses } from "themes/default-tailwind"
import { XIcon } from "themes/default-tailwind/icons"
import { iconSize } from "themes/default-tailwind/plugins/map-icons/constants"

const offsetY = iconSize
const offsetX = 10

type MapIconsLabelContainerProps = {
    clickHandler: () => void
    name: string
    x: number
    y: number
    onClose?: () => void
}

export const MapIconsLabelContent = ({
    clickHandler,
    x,
    y,
    name,
    onClose,
}: MapIconsLabelContainerProps) => {
    const [scrollPosition, setScrollPosition] = useState({ x: window.scrollX, y: window.scrollY })

    useEffect(() => {
        function getValuesForScroll() {
            setScrollPosition({
                x: window.scrollX,
                y: window.scrollY,
            })
        }

        window.addEventListener("scroll", getValuesForScroll)
        return () => {
            window.removeEventListener("scroll", getValuesForScroll)
        }
    }, [])

    return (
        <ClickAwayListener onClickAway={() => onClose?.()}>
            <div
                className="absolute bg-white text-xs rounded-lg capitalize pl-1 pr-1 flex items-center border-[1px] border-black"
                style={{
                    top: `${y - offsetY - scrollPosition.y}px`,
                    left: `${x + offsetX - scrollPosition.x}px`,
                }}
            >
                <p className="pr-1 font-medium">{name}</p>
                <XIcon
                    onClick={clickHandler}
                    className={`${IconSizeClasses.ExtraSmall} cursor-pointer`}
                />
            </div>
        </ClickAwayListener>
    )
}
